export default __webpack_public_path__ + "static/media/ico-check-mark.d0b2bf6b.svg";